import { render, staticRenderFns } from "./researchDashboard.vue?vue&type=template&id=b1c41b6c&scoped=true"
import script from "./researchDashboard.vue?vue&type=script&lang=js"
export * from "./researchDashboard.vue?vue&type=script&lang=js"
import style0 from "./researchDashboard.vue?vue&type=style&index=0&id=b1c41b6c&prod&lang=scss&scoped=true"
import style1 from "./researchDashboard.vue?vue&type=style&index=1&id=b1c41b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c41b6c",
  null
  
)

export default component.exports